/**
 * Metoda sprawdza czy ju istnieje arkusz o podanej nazwie
 * @param sheetName - nazwa arkusza do sprawdzenia
 * @returns true jeśli arkusz istnieje, false w przeciwnym razie
 */
export async function doesSheetExist(sheetName: string): Promise<boolean> {
    return Excel.run(async (context) => {
        const sheets = context.workbook.worksheets;
        sheets.load("items/name");
        await context.sync();
        const sheetNames = sheets.items.map(sheet => sheet.name);
        return sheetNames.includes(sheetName);
    });
}

/**
 * Metoda tworzy nowy arkusz dla sheetName i danych dodatkowych
 * @param matrix - dane do wstawienia
 */
export async function handleNewSheetInsertionData(sheetName: string, dictionery: boolean = false): Promise<void> {
    // Utwórz nowy arkusz
    await Excel.run(async (context) => {
        const sheets = context.workbook.worksheets;
        const newSheet = sheets.add(sheetName);
        // Ustaw kolor tła nazwy arkusza (zakładki)
        if (dictionery) {
            newSheet.tabColor = "#F0F0F0"; // Kolor dla słowników
        } else {
            newSheet.tabColor = "#E5EEF9"; // Kolor dla raportów
        }
    });
}

/**
 * Metoda czyści istniejący arkusz i wstawia do niego dane
 * @param matrix - dane do wstawienia
 */
export async function handleExistingSheetInsertionData(sheetName: string, dictionery: boolean = false): Promise<void> {
    await Excel.run(async (context) => {
        const sheet = context.workbook.worksheets.getItem(sheetName);
        // Ustaw kolor tła nazwy arkusza (zakładki)
        if (dictionery) {
            sheet.tabColor = "#F0F0F0"; // Kolor dla słowników
        } else {
            sheet.tabColor = "#E5EEF9"; // Kolor dla raportów
        }
        // Usuń wszystkie obrazki/shapes z arkusza
        const shapes = sheet.shapes;
        shapes.load("items");
        await context.sync();

        // Usuń każdy shape (obrazek) z arkusza
        for (let i = shapes.items.length - 1; i >= 0; i--) {
            shapes.items[i].delete();
        }
        await context.sync();

        // Wyczyść zawartość komórek
        const usedRange = sheet.getUsedRange();
        usedRange.load("address");
        await context.sync();
        if (usedRange.address) {
            usedRange.clear();
        }

        // Wyczyść formatowanie wierszy i kolumn - przywróć domyślne wartości
        sheet.getRange("A:AZ").format.columnWidth = 64; // Domyślna szerokość kolumn
        sheet.getRange("1:2000").format.rowHeight = 15; // Domyślna wysokość wierszy

        // Wyczyść wszystkie formatowania z całego arkusza
        sheet.getRange("A1:AZ2000").format.fill.clear();
        sheet.getRange("A1:AZ2000").format.font.bold = false;
        sheet.getRange("A1:AZ2000").format.font.color = "#000000";
        sheet.getRange("A1:AZ2000").format.font.size = 11;
        sheet.getRange("A1:AZ2000").format.horizontalAlignment = "General";
        sheet.getRange("A1:AZ2000").format.verticalAlignment = "Bottom";

        // Wyczyść borders poprzez ustawienie ich na "None"
        const clearRange = sheet.getRange("A1:AZ2000");
        clearRange.format.borders.getItem("EdgeTop").style = "None";
        clearRange.format.borders.getItem("EdgeBottom").style = "None";
        clearRange.format.borders.getItem("EdgeLeft").style = "None";
        clearRange.format.borders.getItem("EdgeRight").style = "None";
        clearRange.format.borders.getItem("InsideVertical").style = "None";
        clearRange.format.borders.getItem("InsideHorizontal").style = "None";

        sheet.getRange("A1:AZ1000").format.wrapText = false;

        // Usuń wszystkie filtry
        try {
            sheet.autoFilter.remove();
        } catch (error) {
            // Ignoruj błąd jeśli nie ma filtrów
        }

        await context.sync();
    });
}